"use client";

import { defaultLocale, type Locale } from "@/lib/i18n";
import AgentUseCasePage from "./AgentUseCasePage";
import { orderProcessing } from "@/content/agent-use-cases/order-processing";

// Thin route wrapper — the catch-all maps a route to a component that takes only `locale`,
// so each available spoke gets a wrapper that binds its use-case data.
export default function OrderProcessingUseCase({
  locale = defaultLocale,
}: {
  locale?: Locale;
}) {
  return <AgentUseCasePage useCase={orderProcessing} locale={locale} />;
}
